<template>
    <v-checkbox v-model="isSelected" class="d-inline-block my-0 py-0 mr-n8" color="primary" hide-details @change="emit"></v-checkbox>
</template>

<script>
import { initExpoEmployer } from "@/assets/variables/inits";
import dayjs from "dayjs";

export default {
    components: {},
    props: {
        value: { type: Object, default: initExpoEmployer }, // form

        date: { type: String, default: null },
        time: { type: Number, default: 8 },
    },
    data: () => ({
        form: initExpoEmployer(),

        isSelected: false,
    }),
    computed: {
        datetime() {
            return this.$dayjs(this.date).set("hour", this.time);
        },
    },
    methods: {
        sync() {
            this.form = initExpoEmployer(this.value);
            this.isSelected = this.form.interview.schedules.some((item) => this.datetime.isSame(item));
        },
        emit() {
            if (this.isSelected) {
                this.form.interview.schedules.push(this.datetime.toISOString());
            } else {
                this.form.interview.schedules = this.form.interview.schedules.filter((item) => !this.datetime.isSame(item));
            }

            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .mdi-checkbox-blank-outline {
    &,
    &::before {
        color: #999 !important;
    }
}
</style>